// File: frontend/src/config/navPermissions.js
// Version: 1.0 (quick-260908-pun, окно 1)
// Date: 2026-09-08
// Назначение: ЕДИНСТВЕННЫЙ держатель правила видимости меню.
//
// 🔴 Правило видимости ОДНО. Раньше `getUserRoleLabel`, `getRoleColor` и `isAllowed`
//    жили ВНУТРИ компонента `Navbar.js`. Копия завела бы второе мнение о правах, а
//    замыкание на `user` не давало бы проверить права иначе как грепом. Модуль
//    ЧИСТЫЙ (ни одного импорта) — его можно ИСПОЛНИТЬ и сверить с эталоном.
//
// 🔴 Четыре ветки `isAllowedByKey` перенесены из `Navbar.js:103-113` БУКВА В БУКВУ.
//    Базовая линия сторожа морозит прежнее тело ДОСЛОВНО и ИСПОЛНЯЕТ его как эталон
//    на 32 синтетических пользователях × 21 ключе (П1т). «Упростить по смыслу»
//    ветку `key === 'reputation'` или список из четырёх ролей молча больше нельзя:
//    права не должны ни расшириться, ни сузиться.

// 🔴 ЗАКРЫТЫЙ СЛОВАРЬ. Посторонняя форма — ИСКЛЮЧЕНИЕ, а не молчаливое `false`:
//    формальный признак опознаёт ФОРМУ, решение требует РОЛИ.
//    [[knowledge_formal_signal_vs_role]]
export const ALLOW_FORMS = ['always', 'tab:', 'role:'];   // ЗАКРЫТЫЙ СЛОВАРЬ ПРЕДИКАТОВ

export const ALLOW_UNKNOWN_MESSAGE = 'navPermissions: посторонняя форма allow — ';

// Перенесено из Navbar.js:16-27 без изменений.
export const getUserRoleLabel = (roles) => {
    if (!roles || roles.length === 0) return 'User';
    const roleNames = roles.map(r => typeof r === 'string' ? r : (r.name || '').toUpperCase());
    if (roleNames.includes('CREATOR')) return 'Creator';
    if (roleNames.includes('SUPERADMIN')) return 'Super Admin';
    if (roleNames.includes('MANAGING_PARTNER')) return 'Partner';
    if (roleNames.includes('ADMINISTRATOR')) return 'Admin';
    if (roleNames.includes('ATTORNEY')) return 'Attorney';
    if (roleNames.includes('PARALEGAL')) return 'Paralegal';
    if (roleNames.includes('CLIENT')) return 'Client';
    return 'User';
};

// Перенесено из Navbar.js:29-38 без изменений. Цвета РОЛЕВЫЕ, не темовые:
// Creator=violet, Partner=amber, Admin=red, Attorney=blue, Paralegal=emerald.
export const getRoleColor = (label) => {
    switch (label) {
        case 'Creator': return { bg: '#faf5ff', text: '#7c3aed', border: '#c4b5fd' };
        case 'Partner': return { bg: '#fffbeb', text: '#b45309', border: '#fcd34d' };
        case 'Admin': return { bg: '#fef2f2', text: '#991b1b', border: '#fecaca' };
        case 'Attorney': return { bg: '#eff6ff', text: '#1e40af', border: '#bfdbfe' };
        case 'Paralegal': return { bg: '#ecfdf5', text: '#065f46', border: '#a7f3d0' };
        default: return { bg: '#f3f4f6', text: '#4b5563', border: '#e5e7eb' };
    }
};

// Перенесено из Navbar.js:103-113. `user` принимается ЯВНО: вне компонента
// замыкания нет. Ветки :104 / :105 / :109 / :112 сохранены буква в букву.
export const isAllowedByKey = (user, key) => {
    if (key === 'dashboard') return true;
    if (user?.allowed_tabs && user.allowed_tabs[key] !== undefined) {
        return user.allowed_tabs[key];
    }
    const roleNames = (user?.roles || []).map(r => typeof r === 'string' ? r : (r.name || '').toUpperCase());
    if (['CREATOR', 'SUPERADMIN', 'ADMINISTRATOR', 'MANAGING_PARTNER'].some((r) => roleNames.includes(r))) {
        return true;
    }
    return key === 'reputation';   // ПРАВИЛО ВИДИМОСТИ — ЕДИНСТВЕННОЕ
};

// Вычислитель предиката по ЗАКРЫТОМУ словарю трёх форм:
//   'always'                  — предиката нет вовсе;
//   'tab:<ключ>'              — прежний `isAllowed('<ключ>')`;
//   'role:<Метка>[|<Метка>]'  — прежний `userRole === '<Метка>'` (через ||).
export const evalAllow = (user, form) => {
    if (!ALLOW_FORMS.some((f) => form === f || form.startsWith(f))) {
        throw new Error(ALLOW_UNKNOWN_MESSAGE + form);
    }
    if (form === 'always') return true;
    if (form.startsWith('tab:')) return !!isAllowedByKey(user, form.slice(4));
    const label = getUserRoleLabel(user?.roles);
    return form.slice(5).split('|').some((r) => label === r);
};
